import React from "react";
import { useNavigate } from "react-router-dom";

const Secthree = () => {

    const navigate = useNavigate();

     const comprehensive ={
        background: '#353995',
        borderRadius: '20px',
    }

    return(
        <>
          <div style={{background: '#EEEE', padding: '30px', paddingBottom: '50px', marginTop: '70px'}}>
               <div className="container mt-5" style={comprehensive}>
                <div className="row p-4 text-center">
                    <h1 className="text-white" style={{fontWeight: '700', fontSize: '55px'}}>Ready to build your <span style={{color:'#F29235'}}>digital <br /> future?</span> </h1>
                    <p className="mt-4 text-white">Let’s discuss your project and see how we can help your business <br /> grow with high-performance web solutions.</p>
                        <div>
                            <button className="butt text-center"  onClick={() => navigate("/contact")}>Talk to us</button>
                            
                        </div>
                        <div className="mt-3">
                            <button className="butts text-center w-500" onClick={() => navigate("/portfolio")}>View our Portfolio</button>
                        </div>
                                                  
                        
                    </div>
                </div>
            </div>         
        </>
    )
}

export default Secthree;